import { Injectable } from '@angular/core';
import { ExceedingAmountEntity } from '../configs/entity.config';
import { Observable } from 'rxjs';
import { ExceedingAmountResponse } from '@dch/products-business-logic';
import { EntityManager, IEntity } from '@proximus/entity-manager';

@Injectable({
  providedIn: 'root',
})
export class ExceedingAmountService {
  constructor() {}

  private static getParameterMap(serviceId: string, type: string) {
    switch (type) {
      case 'bone':
        return { bone: serviceId, type: 'bone' };
      case 'mcs': {
        return { mcs: serviceId, type: 'mcs' };
      }
      case 'telephony': {
        return { telephony: serviceId, type: 'telephony' };
      }
      case 'tv': {
        return { tv: serviceId, type: 'tv' };
      }
    }
  }

  getExceedingAmount(
    payload: any,
  ): Observable<IEntity<ExceedingAmountResponse>> {
    return EntityManager.getEntity(
      ExceedingAmountEntity,
      ExceedingAmountService.getParameterMap(payload.serviceId, payload.type),
    );
  }
}
